import {
  Component, EventEmitter,
  HostListener, Inject,
  Injector,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {WarningComponent} from '../../../../../../../../shared/components/warning/warning.component';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';
import {CommonService} from '../../../../../../../../core/services/common.service';
import {Message} from '../../../../../../../../core/class/message';
import {ServiceTypeService} from '../../../../../../../../core/services/service-type.service';
import {MatDialog, MatDialogRef} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Subject} from "rxjs";
import {ContractService} from "../../../../../../../../core/services/contract.service";
import {ConfigGeneralManageService} from "../../../../../../../../core/services/config-general-manage.service";
import _ from 'lodash';
import {FormControl, NgForm} from "@angular/forms";
import {
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  CdkDragMove,
  moveItemInArray
} from '@angular/cdk/drag-drop';
import { ViewportRuler } from "@angular/cdk/overlay";
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {AutoUserService} from "../../../../../../../../core/services/auto-user.service";
import {EnumContractEnterpriseStatus, EnumContractUserRole} from "../../../../../../../../core/constants/contract";
import {element} from "protractor";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import { CreateContractService } from 'src/app/core/services/create-contract.service';
import { debounceTime, filter } from 'rxjs/operators';
import { ProcedureService } from 'src/app/core/services/procedure.service';

@Component({
  selector: 'app-setup-internal-signing-flow',
  templateUrl: './setup-internal-signing-flow.component.html',
  styleUrls: ['./setup-internal-signing-flow.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SetupInternalSigningFlowComponent implements OnInit, OnDestroy  {
  public listOfDataUserSign = [];
  inputUserValue:any;
  checkShowImage:any = true;
  filteredUserOptions = [];
  isLoadUserSign = false;
  private isFormChanging: boolean;
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  isChangeRoleUser: boolean = false;
  checkData = false;
  roleUser = EnumContractUserRole;
  valueSelectedUserRole: string = (this.roleUser.APPROVE + '');
  enterpriseId: string;
  isValidNoUserExist = false;

  translate: TranslateService;
  searchCtrl: FormControl = new FormControl();
  procedures: any[] = [];
  proceduresFilter: any[] = [];
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  procedureId: any = 'no_use_sign_process';
  procedureIdOld: any = 'no_use_sign_process';

  constructor(private injector: Injector,
              private viewportRuler: ViewportRuler,
              public dialogRef: MatDialogRef<SetupInternalSigningFlowComponent>,
              public autoUserService: AutoUserService,
              private dialog: MatDialog,
              private toastr: ToastrService,
              private commonService: CommonService,
              private message: Message,
              private procedureService: ProcedureService,
              private translateService: TranslateService,
              private router: Router,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.translate = injector.get<TranslateService>(TranslateService);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onNoClick();
    });
    if (data.data){
      this.listOfDataUserSign = data.data;
      localStorage.setItem('dataOldPopup',JSON.stringify(this.listOfDataUserSign))
      this.checkShowImage = data.checkShowImage;
      // this.dataOLD = {...data.data};
    } else {
      this.listOfDataUserSign = [];this.checkShowImage = data.checkShowImage;
    }
  }

  ngOnInit() {
    this.getAllProcedure();
    this.searchCtrl.valueChanges.pipe(debounceTime(500)).subscribe(v => {
      this.proceduresFilter =  [{
        id: 'no_use_sign_process',
        procedureName:  this.translateService.instant('enterprise_contract.no_use_sign_process')
      }].concat(this.procedures).filter(item => {
        const s = this.commonService.extractUnicode(item.procedureName);
        return s.indexOf(this.commonService.extractUnicode(v)) > -1;
      });
    });
  }

  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }
  checkExistedUser(id: string, fullname: string, email: string) {
    const existedList = this.listOfDataUserSign.filter((e) => {
      return e.userId == id;
    });

    if (existedList.length > 0) {
      this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate'), [fullname + ' - ' + email]));
      return true;
    } else {
      return false;
    }
  }
  autocompleteUserSelected($event: any, model: any) {
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if (!this.checkExistedUser(model.id, model.name, model.email)) {
        this.listOfDataUserSign.forEach(ele =>{
          if(!ele.order){
            ele.order = 1
          }
        })
        // Re-set all old members to "APPROVE" role
        this.listOfDataUserSign = this.listOfDataUserSign.map((item, index) => {
          return {
            ...item,
            role: this.isChangeRoleUser ? item.role : this.roleUser.APPROVE + '',
            CTS: item.role == this.roleUser.SIGN ? false : item.CTS,
            showImage: item.role == this.roleUser.SIGN ? false : item.showImage,
          };
        });

        const listOfDataUserSignNewOrder = this.listOfDataUserSign.sort((a, b) => {
          return a.order - b.order;
        })
        this.listOfDataUserSign = [...listOfDataUserSignNewOrder];

        // order before push data
        const orderUserSign = this.listOfDataUserSign.length ? this.listOfDataUserSign[this.listOfDataUserSign.length - 1].order + 1 : 1;
        let RECORD_USER_APPROVE = [...this.listOfDataUserSign.filter(item => item.role === '2')];
        RECORD_USER_APPROVE = RECORD_USER_APPROVE.sort((a, b) => {
          return a.order - b.order;
        });
        const orderUserApprove = RECORD_USER_APPROVE.length ? RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1 : -1;

        this.listOfDataUserSign = [
          ...this.listOfDataUserSign,
          {
            order: this.isChangeRoleUser ? (this.listOfDataUserSign.every((data) => data.role === '2') ? orderUserSign : orderUserApprove) : orderUserSign,
            userId: model.id,
            enterpriseId: model.enterpriseId,
            name: model.name,
            email: model.email,
            role: this.isChangeRoleUser ? (this.listOfDataUserSign.every((data) => data.role === '2') ? this.roleUser.SIGN + '' : this.roleUser.APPROVE + '') : this.roleUser.SIGN + '',
            phone: model.phone,
            isCreatedSide: false,
            CTS:model.CTS,
            showImage:model.showImage,
            userPosition: model.userPosition
          }
        ];

        // remove and repush userSign => userUser order last
        if(this.listOfDataUserSign.length > 1) {
          const dataUserSign = this.listOfDataUserSign.find((item) => item.role === '1');
          this.listOfDataUserSign = [...this.listOfDataUserSign.filter((item) => item.role !== '1')];
          this.listOfDataUserSign.push({
            ...dataUserSign,
            order: this.listOfDataUserSign[this.listOfDataUserSign.length - 1].order + 1
          });
        }

        this.reorderUserSign();
        this.inputUserValue = '';
        this.isValidNoUserExist = false;
        // console.log("setup flow", this.listOfDataUserSign);
      }
    }
  }
  onChangeUserSignSearch(event): void {
    if (this.inputUserValue.trim().length > 0) {
      this.isLoadUserSign = true;
      this.autoUserService.fetchAuto(event)
        .then(result => {
          // console.log(result);
          this.filteredUserOptions = result;
        }).finally(() => {
        this.isLoadUserSign = false;
      });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }
  onChangeOrderApproveSign() {
    this.setFormChanging(true);
  }
  private reorderUserSign(): void {
    this.listOfDataUserSign.sort((a, b) => (a.order || 0) - (b.order || 0));
    this.listOfDataUserSign.forEach((item, index) => {
      item.order = index + 1;
    });
  }
  changeRoleUserSign(value: any, data: any) {
    // if(!this.checkData){
    //   this.dataOLD = this.listOfDataUserSign;
    // }
    if(value == 1) {
      data.showImage = false;
      data.CTS = false;
     // this.isChangeRoleUser = true;
      if(this.listOfDataUserSign.length > 1){
        this.listOfDataUserSign = [...this.listOfDataUserSign.filter((item) => item.userId !== data.userId)];
        this.listOfDataUserSign = [...this.listOfDataUserSign.map((item) => ({
          ...item,
          role: this.roleUser.APPROVE + ''
        }))];
        this.listOfDataUserSign.push({
          ...data,
          order: this.listOfDataUserSign.length + 1,
          role: this.roleUser.SIGN + ''
        });
      } else {
        this.listOfDataUserSign = [];
        this.listOfDataUserSign.push({
          ...data,
          order:1,
          role: this.roleUser.SIGN + ''
        });
      }
    } else {
      this.listOfDataUserSign = [...this.listOfDataUserSign.map((item) => ({
        ...item,
        CTS: data.userId === item.userId ? false : item.CTS,
        showImage: data.userId === item.userId ? false : item.showImage,
      }))];
    }
    this.reorderUserSign();
    this.checkData = true;
  }
  changeCTS(data){
    if(data.CTS){
      data.CTS = true;
      if(this.checkShowImage){
        data.showImage = true;
      }
    }else {
      data.showImage = false;
      data.CTS = false;
    }
  }
  changeChanKy(data){
    if(data.showImage){
      data.showImage = true;
    }else {
      data.showImage = false;
    }
  }
  onClickDeleteElementRecordUser(data: any): void {
    this.listOfDataUserSign = this.listOfDataUserSign.filter(d => d.userId !== data.userId);
    // update role of last user to SIGN
    // if (this.listOfDataUserSign.length > 0) {
    //   this.listOfDataUserSign[this.listOfDataUserSign.length - 1].role = this.roleUser.SIGN + '';
    // }
    if(this.listOfDataUserSign.length === 0) {
      this.isChangeRoleUser = false;
    }
    this.setFormChanging(true);
    this.validateErrorSetUser();
    this.reorderUserSign();
  }
  private validateErrorSetUser(model?) {
    // Kiểm tra trong list ko chua User nào?
    if (this.listOfDataUserSign.length == 0) {
      this.isValidNoUserExist = true;
      return true;
    } else {
      this.isValidNoUserExist = false;
    }
    return false;
  }

  onNoClick() {
    // this.listOfDataUserSign = this.data.data = this.dataOLD;
    // if(this.listOfDataUserSign){
    //   const dialogRef = this.dialog.open(WarningComponent, {
    //     width: '30%',
    //     // Them ten doanh nghiep
    //     data: this.message.getMessage('messages.confirm_cancel')
    //   });
    //   dialogRef.afterClosed().subscribe(rs => {
    //     if (rs) {
    //       this.dialog.closeAll();
    //     }
    //   });
    // }else
    const data = JSON.parse(localStorage.getItem('dataOldPopup'));
    localStorage.removeItem('dataOldPopup');
    localStorage.setItem('procedureIdActive', this.procedureIdOld);
    this.dialogRef.close(data);
  }
  onsave(){
    const validate = this.listOfDataUserSign.filter(ele => ele.role == 1);
    if(validate.length == 0){
      this.toastr.error(this.message.getMessage('validation.error_user_no_set_up'));
      return;
    }
    else {
      this.dialogRef.close(this.listOfDataUserSign);
    }
  }

  checkSendSMSInternalInFlow(): void {

  }

  formChangingCheckSendSMSInternalInFlowEvent() {

  }

  clickSend(data) {

  }

  deleteComponent(event) {

  }
  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }
  
  getAllProcedure() {
    this.procedureService.searchProcedure(
      {
        name: null,
        status: [1],
        type: [2],
        enterpriseId: localStorage.getItem('enterpriseId'),
        page: 0,
        pageSize: 999999999,
        id: null
      }
    ).subscribe(response => {
      if (!response || !response.data) {
        return;
      }
      this.procedures = this.procedures.concat(response.data.dataRow);
      if(this.data.procedureId === 'no_use_sign_process') {
        this.procedureId = this.data.procedureId;
        this.procedureIdOld = this.data.procedureId;
      } else {
        this.procedureId = this.procedures.filter((procedure) => procedure.id === +this.data.procedureId).length ? +this.data.procedureId : 'no_use_sign_process';
        this.procedureIdOld = this.procedures.filter((procedure) => procedure.id === +this.data.procedureId).length ? +this.data.procedureId : 'no_use_sign_process';
      } 
      this.proceduresFilter = [{
        id: 'no_use_sign_process',
        procedureName:  this.translateService.instant('enterprise_contract.no_use_sign_process')
      }].concat(this.procedures);
    });
  }

  async changeProcedure($event: any) {
    this.procedureId = $event.value;
    localStorage.setItem('procedureIdActive', this.procedureId);
    if(this.procedureId && this.procedureId !== 'no_use_sign_process') {
      this.getProcedure($event.value);
    } else {
      this.listOfDataUserSign = [...[]];
    }
  }

  getProcedure(procedureId: any) {
    const procedure = this.procedures.find(value => value.id === procedureId);
    this.procedureService.searchProcedureDetails({
      id: procedureId,
      name: procedure ? procedure.procedureName : '',
      status: [1],
      type: [this.data.type],
      enterpriseId: localStorage.getItem('enterpriseId'),
      page: 0,
      pageSize: 999999999,
      checkMaxApprover: true,
    }).subscribe(async response => {
      const data = response.data;
      if (!data) {
        this.procedureId = 'no_use_sign_process';
        return;
      }

      if (data.userSign && data.userSign.length) {
        let RECORD_USER_PERFORM_SIGN = [];
        data.userSign.sort((a, b) => {
          return b.role - a.role;
        });
        console.log(data.userSign);
        data.userSign.forEach(el => {
          RECORD_USER_PERFORM_SIGN = [
            ...RECORD_USER_PERFORM_SIGN,
            {
              order: el.order,
              userId: el.id,
              enterpriseId: el.enterpriseId,
              name: el.name,
              email: el.email,
              role: el.role + '',
              phone: el.phone,
              isCreatedSide: el.isCreatedSide,
              CTS: el.isSignDigitalCertificate ? true : false,
              showImage: this.checkShowImage ? (el.signConfig ? this.setDataSignConfig(JSON.parse(el .signConfig)).showImage : true) : false,
              userPosition: el.userPosition
            },
          ];
        });
        this.listOfDataUserSign = RECORD_USER_PERFORM_SIGN;
      }
    });
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }

  ngOnDestroy() {
  }


}
